export default class GlobalConstant {
  static RegExpNumberAndLetter = /^[A-Za-z0-9]+$/;

  static RegExpPhoneNo = /^[0-9]{6,11}$/;
}
